import script from "./CSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSlider.vue?vue&type=script&setup=true&lang=ts"

import "./CSlider.vue?vue&type=style&index=0&id=c7095108&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7095108"]])

export default __exports__